/* §65 Ban-73 — recommendation rows at the bottom of the product page.
   - "Complete the gift" (Ban-75: loaded here instead of in Liquid): data-cands = [{k:'r'|'o', u:'/collections/…',
     n:name, p:pronoun}]; each candidate collection is rendered through ?section_id=related-products (24 cards with
     data-fam); keeps ≤6, one per family, none sharing a family with the product on screen (.ezrec data-ezrec-fam);
     needs ≥3, otherwise the next candidate; none left → the block is removed.
     Ban-77: candidate {k:'r', u, x:'/collections/christmas', n, a:[same-person keys]} — 48 best sellers (sort_by), plus
     Christmas in season; keeps only cards whose data-aud or data-rcp is in a (data-aud first), hides out-of-season
     occasions (SEASON) here and in "More Items to Consider".
   - "More Items to Consider": fetches Shopify related recommendations rendered by the related-products section
     (cards from ez-rec-card), drops the product on screen and anything already in "Complete the gift".
   - "Recently Viewed": ids from localStorage "recently-viewed" (written by main-product), minus the product on
     screen, rendered through /search?section_id=recently-viewed; hidden when fewer than 2.
   - Rows: swipe gallery on phone/tablet with dots; ‹ › on desktop when there is more than one page.
   Clicks are handled on window (capture) and never read layout: sizes are measured by ResizeObserver/scroll. */
(function () {
  if (window.__ezrec) return;
  window.__ezrec = 1;

  var rails = [];

  function rail(blk) {
    var tr = blk.querySelector('.ezrec__track');
    if (!tr || tr.__ezr) return;
    var st = { blk: blk, tr: tr, dots: blk.querySelector('.ezrec__dots'), arrows: blk.querySelectorAll('[data-ezrec-nav]'), step: 0, max: 0, pages: 1, on: -1, raf: 0 };
    tr.__ezr = st;
    rails.push(st);

    function measure() {
      var w = tr.clientWidth, cs = getComputedStyle(tr);
      var gap = parseFloat(cs.columnGap) || 0, per = parseFloat(cs.getPropertyValue('--ezrec-per')) || 1;
      var n = tr.children.length;
      st.step = w + gap;
      st.max = Math.max(0, tr.scrollWidth - w);
      st.pages = Math.max(1, Math.ceil(n / per));
      if (st.max < 2) st.pages = 1;
      blk.classList.toggle('is-paged', st.pages > 1);
      if (st.dots && st.dots.children.length !== st.pages) {
        var h = '';
        for (var i = 0; i < st.pages; i++) h += '<span class="ezrec__dot"></span>';
        st.dots.innerHTML = st.pages > 1 ? h : '';
        st.on = -1;
      }
      sync();
    }
    function sync() {
      st.raf = 0;
      var x = tr.scrollLeft, p;
      if (st.pages < 2) p = 0;
      else if (x >= st.max - 2) p = st.pages - 1;
      else p = Math.min(st.pages - 1, Math.round(x / (st.step || 1)));
      st.x = x;
      if (p !== st.on && st.dots) {
        var d = st.dots.children;
        for (var i = 0; i < d.length; i++) d[i].classList.toggle('is-on', i === p);
      }
      st.on = p;
      if (st.arrows.length === 2) {
        st.arrows[0].setAttribute('aria-disabled', x <= 2 ? 'true' : 'false');
        st.arrows[1].setAttribute('aria-disabled', x >= st.max - 2 ? 'true' : 'false');
      }
    }
    tr.addEventListener('scroll', function () { if (!st.raf) st.raf = requestAnimationFrame(sync); }, { passive: true });
    if (window.ResizeObserver) new ResizeObserver(measure).observe(tr);
    else window.addEventListener('resize', measure);
    measure();
  }

  function go(el) {
    var blk = el.closest('.ezrec__blk'), tr = blk && blk.querySelector('.ezrec__track'), st = tr && tr.__ezr;
    if (!st || el.getAttribute('aria-disabled') === 'true') return;
    var dir = +el.getAttribute('data-ezrec-nav') || 1;
    var to = Math.max(0, Math.min(st.max, (st.x || 0) + dir * st.step));
    tr.scrollTo({ left: to, behavior: 'smooth' });
  }
  window.addEventListener('click', function (e) {
    var el = e.target.closest && e.target.closest('[data-ezrec-nav]');
    if (!el) return;
    e.preventDefault();
    go(el);
  }, true);
  window.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var el = e.target.closest && e.target.closest('[data-ezrec-nav]');
    if (!el) return;
    e.preventDefault();
    go(el);
  }, true);

  function cards(html) {
    var box = document.createElement('div');
    box.innerHTML = html;
    var src = box.querySelector('.ezrec-src');
    return src ? Array.prototype.slice.call(src.querySelectorAll('.ezrec__item')) : [];
  }
  function whenNear(el, fn) {
    if (!('IntersectionObserver' in window)) return fn();
    var io = new IntersectionObserver(function (en) {
      if (en[0].isIntersecting) { io.disconnect(); fn(); }
    }, { rootMargin: '0px 0px 600px 0px' });
    var box = el.closest('.ezrec');
    io.observe((box && box.parentNode) || el);
  }

  function getText(url) {
    return fetch(url, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw r.status; return r.text(); });
  }

  /* Ban-77: occasions are shown only in their season (month*100+day windows); memorial gifts only next to a
     memorial product; anything else (awo = all occasions, unknown) always. */
  var SEASON = {
    christmas: [1001, 1225], halloween: [901, 1031], fall_season: [901, 1130], valentine: [102, 214],
    easter_day: [301, 420], easter: [301, 420], mothers_day: [401, 511], fathers_day: [512, 621], graduation: [415, 630],
    back_to_school: [701, 915], independence: [601, 704], independence_day: [601, 704], america_250: [601, 704],
    memorial: null, memorial_loved_ones: null, memorial_lost_pets: null
  };
  var NOW = (function () { var d = new Date(); return (d.getMonth() + 1) * 100 + d.getDate(); })();
  function inSeason(o) {
    if (!o || o === 'awo' || !SEASON.hasOwnProperty(o)) return true;
    var w = SEASON[o];
    return !!w && NOW >= w[0] && NOW <= w[1];
  }
  function occOk(o, cur) { return !o || o === cur || inSeason(o); }
  function seasonal(o) { return !!o && o !== 'awo' && !!SEASON[o] && inSeason(o); }
  function csv(attr) { return (attr || '').split(',').filter(Boolean); }

  function gift(blk) {
    var root = blk.closest('.ezrec'), pid = root && root.getAttribute('data-ezrec-pid');
    var own = (root && root.getAttribute('data-ezrec-fam')) || ',', cur = (root && root.getAttribute('data-ezrec-occ')) || '';
    var cands = [];
    try { cands = JSON.parse(blk.getAttribute('data-cands')) || []; } catch (e) { cands = []; }
    return new Promise(function (done) {
      function next(i) {
        if (i >= cands.length) { blk.remove(); return done(); }
        var c = cands[i], urls = [c.u];
        if (c.k === 'r' && c.x && inSeason('christmas')) urls.push(c.x);
        Promise.all(urls.map(function (u) {
          return getText(u + '?sort_by=best-selling&section_id=related-products').catch(function () { return ''; });
        })).then(function (htmls) {
          var pool = [], seen = {};
          seen[pid] = 1;
          htmls.forEach(function (html, pi) {
            cards(html).forEach(function (li, k) {
              var id = li.getAttribute('data-pid');
              if (seen[id]) return;
              seen[id] = 1;
              var fams = csv(li.getAttribute('data-fam')), o = li.getAttribute('data-occ') || '';
              if (!fams.length || !occOk(o, cur)) return;
              var strong = 1;
              if (c.a) {
                var aud = li.getAttribute('data-aud') || '';
                if (aud === 'children') aud = 'kids';
                var rcp = csv(li.getAttribute('data-rcp'));
                if (c.a.indexOf(aud) > -1) strong = 0;
                else if (!rcp.some(function (r) { return c.a.indexOf(r) > -1; })) return;
              }
              pool.push({ li: li, fams: fams, s: [strong, seasonal(o) ? 0 : 1, pi, k] });
            });
          });
          // same main recipient first, then this season's occasion (Christmas now), then best-selling order
          pool.sort(function (a, b) {
            for (var n = 0; n < 4; n++) if (a.s[n] !== b.s[n]) return a.s[n] - b.s[n];
            return 0;
          });
          var used = ',', picks = [];
          pool.forEach(function (it) {
            if (picks.length >= 6) return;
            for (var k = 0; k < it.fams.length; k++) {
              var f = ',' + it.fams[k] + ',';
              if (own.indexOf(f) > -1 || used.indexOf(f) > -1) return;
            }
            used += it.fams.join(',') + ',';
            picks.push(it.li);
          });
          if (picks.length < 3) return next(i + 1);
          // Ban-76: short heading (never wraps on a phone), recipient in the line under it, no "Shop all" link
          var h = blk.querySelector('.ezrec__h'), sub = blk.querySelector('.ezrec__sub');
          if (c.k === 'r') {
            h.textContent = 'Complete the gift';
            sub.textContent = 'More ways to make ' + c.n + ' smile';
          } else {
            h.textContent = 'More ' + c.n + ' gifts';
            sub.textContent = 'Pair it with another personalized gift';
          }
          var tr = blk.querySelector('.ezrec__track');
          picks.forEach(function (li) { tr.appendChild(li); });
          blk.hidden = false;
          rail(blk);
          done();
        });
      }
      whenNear(blk, function () { next(0); });
    });
  }

  function related(blk, giftReady) {
    var root = blk.closest('.ezrec'), pid = root && root.getAttribute('data-ezrec-pid');
    whenNear(blk, function () {
      Promise.all([getText(blk.getAttribute('data-url')), giftReady])
        .then(function (res) { return res[0]; })
        .then(function (html) {
          var seen = {};
          if (pid) seen[pid] = 1;
          Array.prototype.forEach.call(root.querySelectorAll('[data-ezrec="ctg"] .ezrec__item'), function (li) { seen[li.getAttribute('data-pid')] = 1; });
          var cur = root.getAttribute('data-ezrec-occ') || '';
          var list = cards(html).filter(function (li) {
            var id = li.getAttribute('data-pid');
            if (seen[id] || !occOk(li.getAttribute('data-occ') || '', cur)) return false;
            seen[id] = 1;
            return true;
          }).slice(0, 12);
          if (list.length < 2) return blk.remove();
          var tr = blk.querySelector('.ezrec__track');
          list.forEach(function (li) { tr.appendChild(li); });
          blk.hidden = false;
          rail(blk);
        })
        .catch(function () { blk.remove(); });
    });
  }

  function recent(blk) {
    var pid = blk.getAttribute('data-pid'), ids = [];
    try { ids = JSON.parse(localStorage.getItem('recently-viewed')) || []; } catch (e) { ids = []; }
    if (!Array.isArray(ids)) ids = [];
    var seen = {}, pick = [];
    ids.forEach(function (id) {
      id = String(id);
      if (!/^\d+$/.test(id) || id === pid || seen[id] || pick.length >= 8) return;
      seen[id] = 1;
      pick.push(id);
    });
    if (pick.length < 2) return blk.remove();
    whenNear(blk, function () {
      var q = pick.map(function (id) { return 'id:' + id; }).join(' OR ');
      var url = (blk.getAttribute('data-url') || '/search') + '?type=product&q=' + encodeURIComponent(q) + '&section_id=recently-viewed';
      fetch(url, { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw r.status; return r.text(); })
        .then(function (html) {
          var by = {};
          cards(html).forEach(function (li) { by[li.getAttribute('data-pid')] = li; });
          var list = pick.map(function (id) { return by[id]; }).filter(Boolean).slice(0, 4);
          if (list.length < 2) return blk.remove();
          var ul = blk.querySelector('.ezrec__rv');
          list.forEach(function (li) { ul.appendChild(li); });
          blk.hidden = false;
        })
        .catch(function () { blk.remove(); });
    });
  }

  function start() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-ezrec="rel"]'), function (b) {
      if (b.__ezs) return;
      b.__ezs = 1;
      var g = b.closest('.ezrec').querySelector('[data-ezrec="ctg"]');
      var ready = g && !g.__ezs ? (g.__ezs = 1, gift(g)) : Promise.resolve();
      related(b, ready);
    });
    Array.prototype.forEach.call(document.querySelectorAll('[data-ezrec="rv"]'), function (b) { if (!b.__ezs) { b.__ezs = 1; recent(b); } });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
})();
